export enum CommunicationsResponseConferenceParticipantCreateError {
  unableToCreateParticipant = 'unableToCreateParticipant',
}
